import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function HeroSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#2a1f14] text-white pt-12 pb-20 px-4 relative overflow-hidden" data-id="element-73">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-[#c9a96e]/15 blur-[100px] rounded-full pointer-events-none" data-id="element-74"></div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-75">
        <h1 className="font-oswald text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-8 text-white drop-shadow-lg uppercase tracking-tight" data-id="element-76">
          Cómo dejar de sobrepensar, calmar tu mente y recuperar la paz mental
          en pocos minutos al día
        </h1>

        <div className="mb-10 cursor-pointer group" onClick={scrollToCompra} data-id="element-77">
          <img src="https://cdn.magicpatterns.com/uploads/4mZ4LNCUAzk91huCv93jrq/va.jpg" alt="Mega Pack Claridad Mental" className="mx-auto max-w-full md:max-w-2xl rounded-xl shadow-[0_0_30px_rgba(201,169,110,0.2)] group-hover:shadow-[0_0_40px_rgba(201,169,110,0.35)] transition-all duration-300 transform group-hover:-translate-y-1" data-id="element-78" />
          <p className="text-sm text-gray-400 mt-3 font-opensans italic" data-id="element-79">
            Haz clic en la imagen para acceder ahora
          </p>
        </div>

        <h2 className="font-opensans text-xl md:text-2xl text-gray-200 mb-10 max-w-4xl mx-auto leading-relaxed" data-id="element-80">
          Descubre las enseñanzas simples de un monje que están ayudando a miles
          de personas a entender su mente, reducir el estrés mental y vivir con
          más claridad.
        </h2>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-12 font-opensans text-lg font-semibold text-gray-100" data-id="element-81">
          <div className="flex items-center gap-2" data-id="element-82">
            <CheckIcon className="w-6 h-6 text-[#7a9e7a] flex-shrink-0" data-id="element-83" />
            <span data-id="element-84">Sin técnicas complicadas</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-85">
            <CheckIcon className="w-6 h-6 text-[#7a9e7a] flex-shrink-0" data-id="element-86" />
            <span data-id="element-87">Sin teoría innecesaria</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-88">
            <CheckIcon className="w-6 h-6 text-[#7a9e7a] flex-shrink-0" data-id="element-89" />
            <span data-id="element-90">Solo prácticas simples para tu vida diaria</span>
          </div>
        </div>

        <div className="mt-8" data-id="element-91">
          <CtaButton text="QUIERO CALMAR MI MENTE AHORA" data-id="element-92" />
        </div>
      </div>
    </section>;
}